<template>
  <div>
    <div class="setupBox d-sm-flex pa-4">
      <div>
        <div class="title" :class="colorClass">{{ infoText.title }}</div>
        <div class="description">{{ infoText.description }}</div>
      </div>
      <v-spacer v-if="$vuetify.breakpoint.smAndUp"></v-spacer>
      <div>
        <div v-if="!is_account">
          <v-btn
            class="text-none btnClass"
            color="#2D8CFF"
            height="44"
            @click="
              toggleBankInfo({ show: true, type: 'add', groupInfo: group })
            "
          >
            <span> Setup Profile </span>
          </v-btn>
        </div>
        <div
          class="text-right"
          v-else-if="
            this.paymentInfo.verification_status === 'Pending' ||
            this.paymentInfo.verification_status === 'Rejected'
          "
        >
          <!-- <v-chip :class="`${paymentInfo.verification_status} pa-5 px-6`">
            {{ paymentInfo.verification_status }}
          </v-chip> -->
          <v-btn
            class="text-none btnClass px-10"
            color="#2D8CFF"
            height="44"
            @click="
              toggleBankInfo({
                show: true,
                type: 'edit',
                id: group.admin_payment_info.id,
              })
            "
          >
            <span> Edit </span>
          </v-btn>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from "vuex";
export default {
  name: "PaymentSetupCard",
  props: {
    group: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {};
  },
  computed: {
    is_account() {
      return this.group.is_admin_payment_info;
    },
    paymentInfo() {
      return this.group.admin_payment_info;
    },
    infoText() {
      if (this.is_account) {
        if (this.paymentInfo.verification_status === "Pending") {
          return {
            title: "KYC & Payout Information In Review",
            description:
              "Our team will verify your details, then you can start using this group",
          };
        } else if (this.paymentInfo.verification_status === "Rejected") {
          return {
            title: "KYC & Payout Info Rejected",
            description: this.paymentInfo.remark,
          };
        } else {
          return {
            title: "Your Bank Info is Verified",
            description: "",
          };
        }
      } else {
        return {
          title: "Provide Payout Information",
          description:
            "Please provide us your bank account details to activate this group.",
        };
      }
    },
    colorClass() {
      if (this.is_account) {
        if (this.paymentInfo.verification_status === "Pending") {
          return "warning--text";
        } else if (this.paymentInfo.verification_status === "Rejected") {
          return "error--text";
        } else {
          return "";
        }
      } else {
        return "";
      }
    },
  },
  watch: {},
  methods: {
    ...mapActions({
      toggleBankInfo: "payment/toggleBankInfo",
    }),
  },
  mounted() {},
  created() {},
};
</script>
<style scoped>
.setupBox {
  background: linear-gradient(
    89.98deg,
    #d9eafe 0.29%,
    #e0f8ff 49.1%,
    #e0ffed 93.24%
  );
  border-radius: 8px;
}
.title {
  font-family: "Avenir";
  font-style: normal;
  font-weight: 800;
  font-size: 20px;
  line-height: 27px;

  color: #333333;
}
.description {
  font-family: "Avenir";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 19px;
  letter-spacing: -0.01em;

  color: rgba(51, 51, 51, 0.7);
}
.btnClass >>> span {
  font-family: "Avenir";
  font-style: normal;
  font-weight: 900;
  font-size: 16px;
  line-height: 22px;
  /* identical to box height */

  text-align: center;

  color: #ffffff;
}
span.v-chip.Pending {
  background: #fcebdb;
  border-radius: 76px;
  font-family: "Avenir";
  font-style: normal;
  font-weight: 900;
  font-size: 16px;
  line-height: 22px;
  /* identical to box height */

  text-align: center;

  color: #f2994a;
}
span.v-chip.Rejected {
  background: #fbdddd;
  border-radius: 76px;
  font-family: "Avenir";
  font-style: normal;
  font-weight: 900;
  font-size: 16px;
  line-height: 22px;
  /* identical to box height */

  text-align: center;

  color: #eb5757;
}
</style>
